<template>
  <FocusTrap :initial-focus="() => $refs.initialFocusElement">
    <div
      ref="initialFocusElement"
      class="app-cookie-policy-popup"
      data-aos="fade-up"
      :data-aos-offset="0"
      tabindex="-1"
    >
      <AppContainer>
        <div class="popup-dialog">
          <section class="popup-content">
            <header class="popup-content__header">
              <h4 class="popup-content__title">We use cookies</h4>
            </header>
            <p class="popup-content__text">
              We provide you with a better browsing experience and to to help our website run effectively, our site uses
              selected cookies to store information. We will only set cookies which are not strictly necessary if you
              consent, including analytics cookies and cookies used to track any activity which is relevant to our
              website and its services. If you wish to view our Cookie Policy, please review our
              <a :href="privacyPoliciesUrl" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
            </p>
          </section>

          <div class="popup-actions">
            <AppButton class="action-btn" @click="$emit('accept')">Accept all</AppButton>
            <AppButton class="action-btn" inverse @click="$emit('manage')">Manage cookies</AppButton>
          </div>
        </div>
      </AppContainer>
    </div>
  </FocusTrap>
</template>

<script>
import { FocusTrap } from 'focus-trap-vue';
import AppContainer from '@/components/AppContainer.vue';
import AppButton from '@/components/AppButton.vue';
import AppConfig from '@/config';

export default {
  components: { AppButton, AppContainer, FocusTrap },
  data() {
    return {
      privacyPoliciesUrl: AppConfig.get('marketingSite').privacyPoliciesUrl,
    };
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-cookie-policy-popup {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: calc(vars.$app-cookie-policy-popup-overlay-z-index + 1);
  padding: 32px 6px;
  background-color: vars.$c-total-white;
  box-shadow: 0 0 18px rgba(vars.$c-total-black, 0.2);

  @media (min-width: vars.$desktop-lg-992-break-point) {
    padding-top: 42px;
    padding-bottom: 42px;
  }

  .popup {
    &-dialog {
      display: flex;
      flex-direction: column;
      gap: 36px;

      @media (min-width: vars.$desktop-lg-992-break-point) {
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        gap: 180px;
      }
    }

    &-content {
      flex: 1;

      &__header {
        margin-bottom: 24px;
      }

      &__title {
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 3px;
        text-transform: uppercase;
      }

      &__text {
        color: vars.$c-dark-5b;
        font-size: 15px;
        line-height: 1.5;

        a {
          color: vars.$c-link-7b;
          font-weight: 400;
          text-decoration: underline;

          &:hover {
            color: vars.$c-link-7b !important;
          }
        }
      }
    }

    &-actions {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 100%;

      @media (min-width: vars.$desktop-lg-992-break-point) {
        width: 244px;
      }

      .action-btn {
        height: 42px;
        font-size: 14px;

        @media (min-width: vars.$tablet-break-point + 1) {
          height: 42px;
        }
      }
    }
  }
}
</style>
